import { MutationActionCreatorResult, QueryActionCreatorResult } from '@reduxjs/toolkit/dist/query/core/buildInitiate'

export const unwrapQueryActionResult = async <T>(result: QueryActionCreatorResult<any>): Promise<T> => {
  try {
    return (await result.unwrap()) as T
  } finally {
    result.unsubscribe()
  }
}

export const unwrapMutationActionResult = async <T>(result: MutationActionCreatorResult<any>): Promise<T> => {
  try {
    return (await result.unwrap()) as T
  } finally {
    result.reset()
  }
}
